import { GradientStrategy } from "../../../../lib/layers/selectable/color/strategies";
export class LinearStrategy extends GradientStrategy {
    constructor() {
        super();
        this.name = 'Linear';
    }
    generate_colors(color_range) {
        const start = this.hex2rgb(color_range.start);
        const end = this.hex2rgb(color_range.end);
        const interval_length = 1 / (color_range.steps - 1);
        let gradient = Array(color_range.steps);
        for (let i = 0; i < color_range.steps; i++) {
            gradient[i] = [
                Math.round(start[0] * (1 - i * interval_length) + end[0] * i * interval_length),
                Math.round(start[1] * (1 - i * interval_length) + end[1] * i * interval_length),
                Math.round(start[2] * (1 - i * interval_length) + end[2] * i * interval_length)
            ];
        }
        color_range.update_jenks(gradient.map(v => this.rgb2hex(v)));
        return gradient.map(v => this.rgb2hex(v));
    }
}
